import React, { useEffect } from 'react';
import { SaveOutlined } from '@ant-design/icons';
import useTranslate from '@hooks/useTranslate';
import { CheckboxField, TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { Button, Col, Flex, Form, Row } from 'antd';

import "./index.scss";

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
    colon: false,
};

const PrinterSettingForm = ({ formId, settingObj, onSubmit, setIsChangedFormValues, isChangedFormValues, loadingUpdate }) => {
    const translate = useTranslate();
    const [ form ] = Form.useForm();

    const onValuesChange = () => {
        setIsChangedFormValues(true);
    };

    useEffect(() => {
        form.setFieldsValue(settingObj);
    }, [ settingObj, form ]);

    const renderPrinter = (index) => {
        return (
            <tr key={index}>
                <td>{translate.formatMessage(commonMessage.printer) + ' ' + (index + 1)}</td>
                <td className='td-name'>
                    <div>
                        <TextField
                            name={[ 'printers', index, 'name' ]}
                            label={translate.formatMessage(commonMessage.namePrinter)}
                            {...formItemLayout}
                        />
                    </div>
                    <div>
                        <TextField
                            name={[ 'printers', index, 'group_name' ]}
                            label={translate.formatMessage(commonMessage.groupNamePrinter)}
                            {...formItemLayout}
                        />
                    </div>
                </td>
                <td>
                    <div>
                        <TextField
                            name={[ 'printers', index, 'ip' ]}
                            label={translate.formatMessage(commonMessage.ip)}
                            {...formItemLayout}
                        />
                    </div>
                    <div>
                        <CheckboxField
                            name={[ 'printers', index, 'is_white' ]}
                            optionLabel={translate.formatMessage(commonMessage.isWhite)}
                        />
                    </div>
                </td>
                <td>
                    <Row>
                        <Col span={8}>
                            <CheckboxField
                                name={[ 'printers', index, 'is_check' ]}
                                optionLabel={translate.formatMessage(commonMessage.isCheck)}
                            />
                        </Col>
                        <Col span={8}>
                            <CheckboxField
                                name={[ 'printers', index, 'is_print_time' ]}
                                optionLabel={translate.formatMessage(commonMessage.isPrintTime)}
                            />
                        </Col>
                        <Col span={8}>
                            <CheckboxField
                                name={[ 'printers', index, 'is_next_course' ]}
                                optionLabel={translate.formatMessage(commonMessage.isNextCourse)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8}>
                            <CheckboxField
                                name={[ 'printers', index, 'is_beep' ]}
                                optionLabel={translate.formatMessage(commonMessage.isBeep)}
                            />
                        </Col>
                        <Col span={16}>
                            <CheckboxField
                                name={[ 'printers', index, 'is_print_separator' ]}
                                optionLabel={translate.formatMessage(commonMessage.isPrintSeparator)}
                            />
                        </Col>
                    </Row>
                </td>
            </tr>
        );
    };

    return (
        <Form
            id={formId}
            form={form}
            layout="horizontal"
            onFinish={onSubmit}
            initialValues={settingObj}
            onValuesChange={onValuesChange}
        >
            <table className="printer-setting-table">
                <tbody>
                    {renderPrinter(0)}
                    {renderPrinter(1)}
                    {renderPrinter(2)}
                    {renderPrinter(3)}
                    {renderPrinter(4)}
                    {renderPrinter(5)}
                    {renderPrinter(6)}
                    {renderPrinter(7)}
                    {renderPrinter(8)}
                    {renderPrinter(9)}
                </tbody>
            </table>
            <Flex justify="end">
                <Button
                    style={{ marginLeft: '10rem', marginTop: 12 }}
                    key="submit"
                    htmlType="submit"
                    type="primary"
                    disabled={!isChangedFormValues}
                    loading={loadingUpdate}
                >
                    <div>
                        <SaveOutlined style={{ marginRight: '6px' }} />
                        {translate.formatMessage(commonMessage.update)}
                    </div>
                </Button>
            </Flex>
        </Form>
    );
};

export default PrinterSettingForm;